import { Deserializer } from 'jsonapi-serializer';
import { genericError } from "../models/GenericError";
import { ListQuery } from "../models/ListQuery";
import { VingCardDoor, VingCardDoorWrapper } from "../models/VingCardDoor";
import { apiConnector } from "./presetService";
import { createPagination } from "./utilities/paginationBuilder";
import { getConstraintViolation, processServerError } from "./utilities/ServiceError";
import { createPartialURL, getFilterClause } from "./utilities/urlBuilder";
import { VingCardTimeSchedule, VingCardTimeScheduleWrapper } from '../models/VingCardTimeSchedule';
import { Name, NameWrapper } from '../models/Name';

export const getVingCardDoors = async (listParameters?: ListQuery): Promise<VingCardDoorWrapper> => {
    try {
        const filters: string = getFilterClause(listParameters?.filters, listParameters?.searchTerm);
        const paginationString = createPartialURL(listParameters?.goToPage, listParameters?.pageSize, listParameters?.sortBy, filters);
        const vingCardDoorFields = "fields[vingCardDoor]=doorName,doorGroupID,doorGroup";
        const url = `vingCardDoor?${paginationString}&${vingCardDoorFields}`;
        const response = await apiConnector.fetchData(url);
        const json = await response.json();
        const newPagination = createPagination(json.meta);

        return new Promise((resolve, reject) => {
            if (json.errors) {
                return reject({ status: response.status, message: getConstraintViolation(json.errors[0].detail) })
            }

            new Deserializer().deserialize(json, (err: any, vingCardDoors: any[]) => {
                if (err) {
                    return reject({ status: response.status, message: genericError });
                }

                const doors: VingCardDoor[] = vingCardDoors.map(door => {
                    return {
                        id: door['id'],
                        name: door['door-name'],
                        groupId: door['door-group-id'],
                        group: door['door-group']
                    }
                });

                return resolve({ rows: doors, pagination: newPagination });
            })
        })
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error))
        })
    }
}

export const getVingCardTimeScheduleNamesWithPagination = async (listParameters?: ListQuery): Promise<NameWrapper> => {
    try {
        const filters: string = getFilterClause(listParameters?.filters, listParameters?.searchTerm);
        const paginationString = createPartialURL(listParameters?.goToPage, listParameters?.pageSize, listParameters?.sortBy, filters);
        const vingCardDoorFields = "fields[vingCardTimeSchedule]=timeSchedule";
        const url = `vingCardTimeSchedule?${paginationString}&${vingCardDoorFields}`;
        const response = await apiConnector.fetchData(url);
        const json = await response.json();
        const newPagination = createPagination(json.meta);

        return new Promise((resolve, reject) => {
            if (json.errors) {
                return reject({ status: response.status, message: getConstraintViolation(json.errors[0].detail) })
            }

            new Deserializer().deserialize(json, (err: any, data: any[]) => {
                if (err) {
                    return reject({ status: response.status, message: genericError });
                }

                const vingCardTimeSchedules: Name[] = data.map(timeSchedule => {
                    return {
                        value: timeSchedule['id'],
                        label: timeSchedule['time-schedule']
                    }
                });

                return resolve({ rows: vingCardTimeSchedules, pagination: newPagination });
            })
        })
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error))
        })
    }
}